export default __webpack_public_path__ + "static/media/bankid-signering_274.5x28.5ed9cace.svg";